import { render, staticRenderFns } from "./ProductCategoryAddView.vue?vue&type=template&id=26f0338b&scoped=true&"
import script from "./ProductCategoryAddView.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f0338b",
  null
  
)

export default component.exports